// import { FORM_ERROR } from 'final-form';
import { is, isEmpty } from 'ramda';

export function deleteFormField(fields, index, { moveToEnd = false } = {}) {
  const item = fields.value[index];

  if (item?.id) {
    fields.update(index, { ...item, _destroy: true });
    if (moveToEnd) {
      fields.move(index, fields.length - 1);
    }
  } else {
    fields.remove(index);
  }
}

export function getArrayByKeys(obj = {}, keys) {
  return keys.reduce((acc, cur) => {
    acc[cur] = is(Array, obj[cur]) && !isEmpty(obj[cur]) ? obj[cur] : [{}];

    return acc;
  }, {});
}
